angular.module('unergie.main')
.filter('rawHtml', ($sce) =>
    (val) => $sce.trustAsHtml(val),
)
